import type { PropsWithChildren } from "react";
import { distinct } from "@entrilia/shared/utilities/arrayHelper";
import storage from "../../storage/storage";
import { MainMenuContext } from "./MainMenuContext";

export const MainMenuContextProvider = ({ children }: PropsWithChildren) => {
  const persistedClosedItems = storage.getClosedMainMenuItems();

  const addClosedItem = (item: string) => {
    storage.saveClosedMainMenuItems(distinct([...storage.getClosedMainMenuItems(), item]));
  };

  const removeClosedItem = (item: string) => {
    storage.saveClosedMainMenuItems(storage.getClosedMainMenuItems().filter((i) => i !== item));
  };

  return (
    <MainMenuContext value={{ persistedClosedItems, addClosedItem, removeClosedItem }}>{children}</MainMenuContext>
  );
};
